import { config } from "../enviroment";
import axios from "axios";

  
  export const communicationService = {
    getAnnouncementData
  };

  async function getAnnouncementData(languageCode) {
    return new Promise((resolve, reject) => {
      axios({
        url: config.urls.COMMUNICATION_SERVICE_BASE_URL,
      method: "post",
      headers: { "Content-Type": "application/json",languageCode:languageCode},
      data: {
        query:
          'query{getAnnouncementList(input:{IsPublic:"PUBLIC"}){AnnouncementId,AnnouncementTitle,AnnouncementDescription,IsPublic,ExpirationDateTime,CreateDateTime,StartDate}}'
      },
          
        })
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }


